export default "__VITE_ASSET__DgNr_SiF__"